/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/UserLink.js
 */

import React from 'react';

const getLink = (data) => `/#/search?query=${data.deliverySystemAccountId}`;

const UserLink = ({ data }) => {
  const link = getLink(data);
  return (
    <div className="Summary">
      <div className="SummaryTitle">
        <a href={link}>
          <div className="Type">User</div>
          <div className="Value">{data.userName}</div>
        </a>
      </div>
      <div className="SummaryLink">
        <a href={link}>{link}</a>
      </div>
      <div className="SummaryData">
        <p>
          Delivery System :{' '}
          {data.deliverySystemAccountId
            ? data.deliverySystemAccountId
            : 'No delivery system account associated with this user'}
        </p>
        <p>{`Name : ${data.name}`}</p>
        <p>{`email : ${data.email}`}</p>
      </div>
    </div>
  );
};

export default UserLink;
